"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Directives = void 0;
exports.Directives = {
    Required: 'required',
    Allowed: 'allowed',
    Disallowed: 'disallowed'
};
